/**
 * Utility to extract IReference[] from mention nodes in a TipTap editor document.
 */
import { Editor } from "@tiptap/core";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { MentionType } from "./mention-type.enum";

export interface IMentionRef {
  refType: BackendResourceEnum;
  refId: string;
}

/**
 * Walk the ProseMirror document tree and collect all mention nodes as IReference[].
 * Handles both userMention and refMention node types.
 */
export function extractMentionRefs(editor: Editor): IMentionRef[] {
  const refs: IMentionRef[] = [];
  const seen = new Set<string>();

  editor.state.doc.descendants((node) => {
    if (node.type.name === MentionType.USER && node.attrs.id) {
      const key = `${BackendResourceEnum.USER}:${node.attrs.id}`;
      if (!seen.has(key)) {
        seen.add(key);
        refs.push({ refType: BackendResourceEnum.USER, refId: node.attrs.id });
      }
    }

    if (node.type.name === MentionType.REF && node.attrs.id && node.attrs.refType) {
      const key = `${node.attrs.refType}:${node.attrs.id}`;
      if (!seen.has(key)) {
        seen.add(key);
        refs.push({ refType: node.attrs.refType, refId: node.attrs.id });
      }
    }
  });

  return refs;
}
